import { KTagWithIcon } from '@/ui-library/components';
import { Stars02 } from '@kula-ai/icons/dual-tone/Stars02';
import {
  interviewIntelligenceStatusMap,
  interviewIntelligenceMergedStatusMap,
} from '../utils/contant';
import { useHistory } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

function getMergedStatus(beStatus: string) {
  return Object.values(interviewIntelligenceMergedStatusMap).find((group) =>
    group.keys.includes(beStatus)
  );
}

export const InterviewIntelligenceStatusTag = ({
  status,
  interviewId,
}: {
  status: string;
  interviewId?: number;
}) => {
  const history = useHistory();
  const merged = getMergedStatus(status);
  const label = merged?.label ?? 'AI notetaker enabled';
  // Use original color/bg fallback for now
  const { bg = 'pastel-3-light', color = 'pastel-3-dark' } =
    interviewIntelligenceStatusMap[status] || {};

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (interviewId) {
      history.push(`/interviews/${interviewId}`);
    }
  };

  return (
    <Box
      display="inline-block"
      cursor={interviewId ? 'pointer' : 'default'}
      onClick={interviewId ? handleClick : undefined}
    >
      <KTagWithIcon
        value={label}
        icon={Stars02}
        iconProps={{ color }}
        bg={bg}
        color={color}
        whiteSpace="nowrap"
      />
    </Box>
  );
};
